import linkStyles from '../../../../shared/styles/link.styles'

const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },

  tableContainer: {
    flex: 1
  },

  // Paired values stacked in one cell — the table has to carry ten fields and
  // still fit a laptop without horizontal scrolling.
  stackedCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: 0
  },

  primaryLine: {
    fontWeight: 500,
    lineHeight: 1.3,
    // Wrap, then clamp. Without an explicit wrap the cell grows to fit the text
    // on ONE line, and a table cell has no width of its own to stop it — an
    // Amazon product title then pushes every column to its right off screen.
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  },

  // Product titles are unbounded (they are whatever the retailer wrote), so this
  // is the one column that must be told how much room it may take. Trimmed from
  // 280 to give the locker bank enough room to render its name in full.
  itemCell: {
    width: 260,
    maxWidth: 260
  },

  // Wide enough for a real bank name ("New Kingston Plaza") to wrap rather than
  // truncate. A half-rendered location reads as broken, and the bank name IS the
  // place support directs someone to.
  bankCell: {
    width: 150,
    maxWidth: 150
  },

  timelineCell: {
    width: 140,
    maxWidth: 140
  },

  secondaryLine: {
    fontSize: '0.75rem',
    opacity: 0.7,
    lineHeight: 1.3,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflow: 'hidden'
  },

  // A link sitting in a line of text, so it takes the line's size rather than a button's, and the
  // dashboard's link colour - the theme gives all text one colour, links included
  rowLink: {
    ...linkStyles,
    font: 'inherit',
    fontWeight: 600,
    verticalAlign: 'baseline'
  },

  emptyStateContainer: {
    paddingTop: 4
  },

  monospaceLine: {
    fontFamily: 'monospace',
    fontSize: '0.8rem',
    whiteSpace: 'nowrap'
  }
}

export default styles
